import React, {Component} from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select/dist/styles.css';
import './react-dropdown-custom.css';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import {codeTables} from "../../codes";

function depthFirstSet(tree, value, updateCallback) {
  tree.find(item => {
    if (item.value === value) {
      updateCallback && updateCallback(item);
      return true;
    }
    if (item.children && Array.isArray(item.children)) {
      return depthFirstSet(item.children, value, updateCallback);
    }
    return false;
  });
}

class DropDownTreeSelectContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { data: this.props.data };
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.data, this.state.data)) {
      this.setState({ data: nextProps.data });
    }
  }

  shouldComponentUpdate(nextProps) {
    return !isEqual(nextProps.data, this.state.data);
  }

  render() {
    const { data, ...rest } = this.props;
    return (
      <DropdownTreeSelect data={this.state.data} {...rest}/>
    );
  }
}

export class CodeTreeSelect extends Component {
  constructor(props) {
    super(props);
    const { codes, value } = this.props;
    let initData = cloneDeep(codes);
    if (value && Array.isArray(value)) {
      value.forEach(code => {
        depthFirstSet(initData, code,node => node.checked = true);
      });
    }
    this.state = { initData, value: value || [] };
  }

  onChange = (currentNode, selectedNodes) => {
    const { onChange } = this.props;
    let newValues = selectedNodes.map(node => node.value)
    this.setState({ value: newValues });
    if (onChange) {
      onChange(newValues);
    }
  };

  render() {
    const {placeholder, onBlur} = this.props;
    const { initData } = this.state;
    return (
      <DropDownTreeSelectContainer
        data={initData}
        onChange={this.onChange}
        placeholderText={placeholder || 'Please select'}
        showPartiallySelected
        keepTreeOnSearch
        onBlur={onBlur}
      />
    );
  }
}

export class CodeTreeSelectFast extends Component {
  constructor(props) {
    super(props);
    const { table, value } = this.props;
    let codeTable = codeTables.get(table);
    let initData = cloneDeep(codeTable);
    if (value && Array.isArray(value)) {
      value.forEach(code => {
        depthFirstSet(initData, code,node => node.checked = true);
      });
    }
    this.state = { initData, value: value || [] };
  }

  onChange = (currentNode, selectedNodes) => {
    const { onChange } = this.props;
    let newValues = selectedNodes.map(node => node.value)
    this.setState({ value: newValues });
    if (onChange) {
      onChange(newValues);
    }
  };

  render() {
    const {placeholder, onBlur} = this.props;
    const { initData } = this.state;
    return (
      <DropDownTreeSelectContainer
        data={initData}
        onChange={this.onChange}
        placeholderText={placeholder || 'Please select'}
        showPartiallySelected
        keepTreeOnSearch
        onBlur={onBlur}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Boilerplate/CodeTreeSelect.js